import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import SimpleTable from './SimpleTable';


export function TenantSelectionTable({tenants=[], setSelectedDataFn}) {

    const renderHostPrefix = (colInfo) => {
        const value = _.get(colInfo, 'cell.value', '');
        if (!_.isEmpty(value) && _.isString(value)) {
            return value.split('.')[0];
        }
        return '';
    };

    const renderProductEdition = (colInfo) => {
        const value = _.get(colInfo, 'cell.value', '');
        if (!_.isEmpty(value) && _.isString(value)) {
            return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
        }
        return '';
    };

    const columns = React.useMemo(
        () => [
            {
                Header: 'Name',
                accessor: 'sitename',
                maxWidth: 400,
                width: 200,

            },
            {
                Header: 'Edition*',
                accessor: 'productEdition',
                maxWidth: 75,
                Cell: renderProductEdition,
            },
            {
                Header: 'Region**',
                accessor: (data) => data.location.name,
                maxWidth: 100,
            },
            {
                Header: 'Tenant URL Prefix',
                accessor: (data) => data.hostname,
                maxWidth: 200,
                Cell: renderHostPrefix,
            },

        ],
        []
    );

    const data = React.useMemo(() => {
        return !_.isEmpty(tenants) ? tenants : [];
    }, [tenants]);



    return (
        <SimpleTable
            id='tenant-selection-table'
            columns={columns}
            data={data}
            setSelectedDataFn={setSelectedDataFn}
        />
    );
}

TenantSelectionTable.propTypes = {
    setSelectedDataFn: PropTypes.func.isRequired,
    tenants: PropTypes.array,

};

TenantSelectionTable.displayName = 'TenantSelectionTable';
export default TenantSelectionTable;